import React, { useState, useEffect, useRef } from 'react'
import { useSelector } from 'react-redux'
import { Button, Row, Col, Input, Image } from 'antd'
import { useHistory } from 'react-router-dom'
import { CheckOutlined } from '@ant-design/icons'
import { handleChange, formatMessageNew, base64Url } from '@/utils/common'
import TagComp from './component/tag'
import AntdTable from '@/components/table/AntdTable'
import { clearAuthentication } from '@/utils/authHelp'
import { getCartonList, pfTagBinding } from '@/services/PFTag/tag'
import { modalError, modalSuccess, modalConfirm } from '@/utils/modalUtils'
import _ from 'lodash'

let instance01 = null
let instance02 = null
let instance03 = null
let instance04 = null
let instance05 = null
let instance06 = null
let instance07 = null
let instanceTagType = null
let errorNumRef = 0
let lastSendDataStr = ''

let gSkuTagObj = {
  carton: '',
  orderNumber: '',
  pendingTagList: []
}

const PFTagPage = () => {
  const [cartonValue, setCartonValue] = useState('')
  const deviceSize = useSelector(state => state.commonStore.deviceSize)
  const [imgObj] = useState({ width: 140 * deviceSize })
  const [skuTagList, setSkuTagList] = useState([])
  const [submitFlag, setSubmitFlag] = useState(false)
  const [gIsTagAllFlag, setGIsTagAllFlag] = useState(false)
  const [skuUpcList, setSkuUpcList] = useState([])
  const [existNfcList, setExistNfcList] = useState([])
  const [orderNumber, setOrderNumber] = useState('')
  const [isShowUI, setIsShowUI] = useState(false)
  const upcNfcInputRef = useRef(null)
  const cartonInputRef = useRef(null)
  const history = useHistory()

  const workstationState = useSelector(state => state.commonStore.workstation)
  const macState = useSelector(state => state.commonStore.mac)

  const tableColumns = [
    {
      title: formatMessageNew('languageObj.pftag.skuTip'),
      width: 100,
      dataIndex: 'sku',
      render: text => {
        return <div className="word_break_all">{text}</div>
      }
    },
    {
      title: formatMessageNew('languageObj.pftag.requiredTagType'),
      width: '15%',
      dataIndex: 'requiredTagTypeList',
      render: (text, record) => {
        return (
          <div>
            {text &&
              text.map((item, idx) => {
                return (
                  <div className="mt10 mb10 displayFlex alignCenter" key={idx}>
                    <span className="tagTypeVal">{item}</span>
                    {record.requiredTagPicBase64List[idx] ? (
                      <>
                        <span className="splitSpan">-</span>
                        <Image
                          rootClassName="imgReviewWrapper"
                          width={imgObj.width}
                          height={imgObj.width / 3.6}
                          src={base64Url(record.requiredTagPicBase64List[idx])}
                        />
                      </>
                    ) : null}
                  </div>
                )
              })}
          </div>
        )
      }
    },
    {
      title: formatMessageNew('languageObj.pftag.upc'),
      width: 100,
      dataIndex: 'upc',
      render: (text, record) => {
        return <div className="word_break_all">{record.isChecked ? record.upc : ''}</div>
      }
    },
    {
      title: formatMessageNew('languageObj.pftag.nfcUid'),
      width: 100,
      dataIndex: 'nfcUid',
      render: text => {
        return <div className="word_break_all">{text}</div>
      }
    },
    {
      title: formatMessageNew('languageObj.pftag.actualTagType'),
      width: 100,
      dataIndex: 'actualTagType',
      render: text => {
        return <div className="word_break_all">{text}</div>
      }
    },
    {
      title: formatMessageNew('languageObj.pftag.tagStatus'),
      width: 100,
      dataIndex: 'isChecked',
      render: text => {
        return text ? <CheckOutlined style={{ color: 'rgb(22, 119, 255)', fontSize: '30px' }} /> : null
      }
    },
    {
      title: formatMessageNew('languageObj.pftag.action'),
      width: 100,
      dataIndex: 'action',
      render: (text, record) => {
        return (
          <Button
            type="primary"
            onClick={() => {
              clearItemBtn(record.rowIndex)
            }}
            style={{ width: 100 }}
            disabled={!record.isChecked}
          >
            {formatMessageNew('languageObj.pftag.clear')}
          </Button>
        )
      }
    }
  ]

  useEffect(() => {
    cartonInputRef.current.focus({
      cursor: 'all'
    })
    window.addEventListener('keydown', onKeyDownBtn) // 添加全局事件
    return () => {
      window.removeEventListener('keydown', onKeyDownBtn) // 销毁
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    if (cartonValue.length === 0) {
      resetBtnClick()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cartonValue])

  // useEffect(() => {

  //   upcNfcInputRef && upcNfcInputRef.current.setTimes()
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [])

  const onKeyDownBtn = e => {
    switch (e.keyCode) {
      case 13:
        // if (
        //   gIsTagAll &&
        //   !instance01 &&
        //   !instance02 &&
        //   !instance03 &&
        //   !instance04 &&
        //   !instance05 &&
        //   !instance06 &&
        //   errorNumRef === 0
        // ) {
        //   submitClick()
        // }
        if (instance01) {
          instance01.destroy()
          instance01 = null
          errorNumRef = 0
        }
        if (instance02) {
          instance02.destroy()
          instance02 = null
          errorNumRef = 0
          // upcNfcInputRef && upcNfcInputRef.current.clearInputs()
        }
        if (instance03) {
          instance03.destroy()
          instance03 = null
          errorNumRef = 0
        }
        if (instance04) {
          instance04.destroy()
          instance04 = null
          errorNumRef = 0
          upcNfcInputRef && upcNfcInputRef.current.clearInputs()
        }
        if (instance05) {
          instance05.destroy()
          instance05 = null
          errorNumRef = 0
        }
        if (instance06) {
          instance06.destroy()
          instance06 = null
          errorNumRef = 0
        }
        if (instance07) {
          instance07.destroy()
          instance07 = null
          errorNumRef = 0
        }
        if (instanceTagType) {
          instanceTagType.destroy()
          instanceTagType = null
          errorNumRef = 0
        }
        break
      default:
        break
    }
  }

  const onKeyDown = e => {
    switch (e.keyCode) {
      case 13:
        getList()
        break
      default:
        break
    }
  }

  const getList = () => {
    if (cartonValue.length === 0) return

    let params = {
      carton: cartonValue
    }
    getCartonList(params)
      .then(res => {
        if (res.errorCode === '200') {
          const taglist = []
          const upclist = []
          const array = res.resultData.pendingTagList
          for (let i = 0; i < array.length; i++) {
            const item = array[i]
            let base64List = []
            if (item.requiredTagPicBase64) {
              base64List = item.requiredTagPicBase64.split(',')
            }
            let requiredTagTypeList = []
            if (item.requiredTagType) {
              requiredTagTypeList = item.requiredTagType.split(',')
            }
            taglist.push({
              ...item,
              isChecked: false,
              sku: item.productCode + '-' + item.productSize,
              rowIndex: i,
              requiredTagTypeList: requiredTagTypeList,
              requiredTagPicBase64List: base64List
            })
            if (upclist.indexOf(item.upc) === -1) {
              upclist.push(item.upc)
            }
          }
          setOrderNumber(res.resultData.orderNumber)
          setSkuTagList(taglist)
          setSkuUpcList(upclist)
          setExistNfcList([])
          setIsShowUI(true)
          upcNfcInputRef && upcNfcInputRef.current.clearInputs()
        }
      })
      .catch(error => {
        resetBtnClick()
        if (error?.data?.errorCode === '401') {
          // nothing to do
        } else {
          if (errorNumRef === 0) {
            errorNumRef = 1
            let msg = ''
            if (error.errorCode === '601') {
              msg = formatMessageNew('languageObj.pftag.cartonDoesNotExist')
            }
            if (error.errorCode === '602') {
              msg = formatMessageNew('languageObj.pftag.cartonDoesNotIncludeNFCSKU')
            }
            if (error.errorCode === '603') {
              msg = formatMessageNew('languageObj.pftag.cartonAlreadyTag')
            }
            if (error.errorCode === '433') {
              msg = formatMessageNew('languageObj.pftag.errorcode_433')
            }
            if (error.errorCode === '604') {
              msg = formatMessageNew('languageObj.pftag.errorcode_604')
            }
            instance03 = modalError(
              {
                content: msg
              },
              () => {
                instance03 = null
                errorNumRef = 0
              }
            )
          }
        }
      })
  }

  const tagItem = (upcValue, nfcValue, tagType) => {
    //产品在箱号列表中不存在
    if (upcValue && skuUpcList.indexOf(upcValue) === -1) {
      if (errorNumRef === 0) {
        errorNumRef = 1
        instance04 = modalError(
          {
            content: formatMessageNew('languageObj.pftag.skuDoesNotExist')
          },
          () => {
            instance04 = null
            errorNumRef = 0
            upcNfcInputRef && upcNfcInputRef.current.clearInputs()
          }
        )
      }
      return
    }
    //NFC已被绑定
    if (nfcValue && existNfcList.indexOf(nfcValue) !== -1) {
      if (errorNumRef === 0) {
        errorNumRef = 1
        instance02 = modalError(
          {
            content: formatMessageNew('languageObj.pftag.alreadyTag')
          },
          () => {
            instance02 = null
            errorNumRef = 0
            // upcNfcInputRef && upcNfcInputRef.current.clearInputs()
          }
        )
      }
      return
    }

    if (upcValue && nfcValue && tagType) {
      const tempList = _.cloneDeep(skuTagList)
      let firstMatchIndex = null
      let firstMatchItem = null
      for (let i = 0; i < skuTagList.length; i++) {
        const e = skuTagList[i]
        // upc可能是重复的, 如果已经绑定了isChecked=true
        if (e.upc === upcValue && !e.isChecked) {
          // 标签不匹配类型
          let requiredTagTypeLs = (e.requiredTagType && e.requiredTagType.split(',')) || []
          if (tagType && tagType !== '0000' && requiredTagTypeLs.indexOf(tagType) === -1) {
            const content = `${e.sku} ${formatMessageNew('languageObj.nsptagLocale.nddcTagTypeNotMatch')} '${
              e.requiredTagType
            }'`
            if (errorNumRef === 0) {
              errorNumRef = 1
              // eslint-disable-next-line
              instance07 = modalError({ content }, () => {
                instance07 = null
                errorNumRef = 0
              })
            }
          } else {
            e.nfcUid = nfcValue
            e.isChecked = true
            e.actualTagType = tagType
            firstMatchIndex = i
            firstMatchItem = e
          }
          break
        }
      }

      if (firstMatchIndex !== null && firstMatchItem !== null) {
        tempList[firstMatchIndex] = firstMatchItem
        setSkuTagList(tempList)
        setExistNfcList([...existNfcList, nfcValue])
      }
      upcNfcInputRef && upcNfcInputRef.current.clearInputs()
      checkTagStatus(tempList)
    }
  }
  useEffect(() => {
    if (skuTagList.length === 0) {
      setGIsTagAllFlag(false)
    } else {
      const noTaglist = skuTagList.filter(item => {
        return item.isChecked === false
      })
      if (noTaglist.length === 0) {
        setGIsTagAllFlag(true)
      } else {
        setGIsTagAllFlag(false)
      }
    }
  }, [skuTagList])
  const checkTagStatus = list => {
    const noTaglist = list.filter(item => {
      return item.isChecked === false
    })
    if (noTaglist.length === 0) {
      upcNfcInputRef && upcNfcInputRef.current.inputBlur()
      gSkuTagObj = {
        carton: cartonValue,
        orderNumber: orderNumber,
        pendingTagList: list
      }
    }
  }

  const clearItemBtn = index => {
    const tempList = []
    for (let i = 0; i < skuTagList.length; i++) {
      const e = skuTagList[i]
      if (index === i) {
        clearNfcList(e.nfcUid)
        e.nfcUid = ''
        e.isChecked = false
        e.actualTagType = undefined
      }
      tempList.push({
        ...e
      })
    }
    setSkuTagList(tempList)
  }

  const clearNfcList = nfcValue => {
    const tempList = existNfcList.filter(item => {
      return item !== nfcValue
    })
    setExistNfcList(tempList)
  }

  const resetBtnClick = () => {
    lastSendDataStr = ''
    setSubmitFlag(false)
    setCartonValue('')
    setOrderNumber('')
    setSkuTagList([])
    setExistNfcList([])
    setIsShowUI(false)
    gSkuTagObj = {
      carton: '',
      orderNumber: '',
      pendingTagList: []
    }
    cartonInputRef.current.focus({
      cursor: 'all'
    })
  }

  const submitClick = () => {
    const list = gSkuTagObj.pendingTagList.filter(item => {
      return item.isChecked === false
    })
    if (list.length > 0) {
      if (errorNumRef === 0) {
        errorNumRef = 1
        instance01 = modalError(
          {
            content: formatMessageNew('languageObj.pftag.taggingAll')
          },
          () => {
            // sendErr = {}
            errorNumRef = 0
            instance01 = null
            // // 清空数据
            // setUpcValue('')
            // setNfcValue('')
            // // 获取焦点
            // inputRef.current.focus({
            //   cursor: 'all'
            // })
            // // 启用定时器
            // setIntervalFlag(!intervalFlag)
            // if (error.errorCode === '401') {
            //   clearAuthentication()
            //   window.location.href = redirectURL
            // }
          }
        )
      }
    } else {
      if (
        gSkuTagObj.carton.length === 0 ||
        gSkuTagObj.orderNumber.length === 0 ||
        gSkuTagObj.pendingTagList.length === 0
      ) {
        return
      }
      let paramsObj = _.cloneDeep(gSkuTagObj)
      let arrList = []
      for (let index = 0; index < paramsObj.pendingTagList.length; index++) {
        let element = paramsObj.pendingTagList[index]
        let objItem = {
          actualTagType: element.actualTagType,
          nfcUid: element.nfcUid,
          productCode: element.productCode,
          productSize: element.productSize,
          // requiredTagType: element.requiredTagType,
          upc: element.upc
        }
        arrList.push(objItem)
      }
      paramsObj.pendingTagList = arrList
      if (lastSendDataStr && lastSendDataStr === JSON.stringify(paramsObj)) {
        // 同一upc和nfc已经发送，防止重复发送
        return
      }
      lastSendDataStr = JSON.stringify(paramsObj)
      setSubmitFlag(true)
      pfTagBinding(paramsObj)
        .then(res => {
          if (res.errorCode === '200') {
            if (errorNumRef === 0) {
              errorNumRef = 1
              instance05 = modalSuccess(
                {
                  content: formatMessageNew('languageObj.pftag.tagSuccess')
                },
                () => {
                  instance05 = null
                  errorNumRef = 0
                }
              )
            }
            resetBtnClick()
          }
        })
        .catch(error => {
          if (errorNumRef === 0) {
            errorNumRef = 1
            let msg = ''
            if (error.errorCode === '417') {
              msg = formatMessageNew('languageObj.pftag.errorcode_417') + ': ' + error.resultData.join('、')
            }
            if (error.errorCode === '903') {
              msg = formatMessageNew('languageObj.pftag.errorcode_903')
            }
            if (error.errorCode === '439') {
              msg = formatMessageNew('languageObj.pftag.errorcode_439')
            }
            if (error.errorCode === '433') {
              msg = formatMessageNew('languageObj.pftag.errorcode_433')
            }
            if (error.errorCode === '416') {
              msg = formatMessageNew('languageObj.pftag.errorcode_416')
            }
            if (error.errorCode === '419') {
              msg = formatMessageNew('languageObj.pftag.errorcode_419')
            }
            if (error.errorCode === '442') {
              msg = formatMessageNew('languageObj.nsptagLocale.NFCUIDDisabled')
            }
            if (error.errorCode === '4171') {
              msg = formatMessageNew('languageObj.pftag.errorcode_4171')
            }
            if (error.errorCode === '901') {
              msg = formatMessageNew('languageObj.pftag.errorcode_901')
            }
            if (error.errorCode === '902') {
              msg = formatMessageNew('languageObj.pftag.errorcode_902')
            }
            if (error.errorCode === '905') {
              // msg = formatMessageNew('languageObj.pftag.errorcode_902')
              msg = `${error.resultData.productCode} ${formatMessageNew(
                'languageObj.nsptagLocale.nddcTagTypeNotMatch'
              )} '${error.resultData.requiredTagType}'`
            }
            instance06 = modalError(
              {
                content: msg
              },
              () => {
                instance06 = null
                errorNumRef = 0
              }
            )
          }
        })
        .finally(() => {
          lastSendDataStr = ''
          setSubmitFlag(false)
        })
    }
  }

  const confirmDialogMac = () => {
    if (!macState) {
      if (errorNumRef === 0) {
        errorNumRef = 1
        modalConfirm(
          {
            content: formatMessageNew('languageObj.nsptagLocale.macError'),
            cancelText: formatMessageNew('languageObj.nsptagLocale.backText'),
            okText: formatMessageNew('languageObj.nsptagLocale.loginText'),
            onCancel: () => {
              errorNumRef = 0
              history.goBack()
            }
          },
          () => {
            errorNumRef = 0
            clearAuthentication()
            history.push('/login')
          }
        )
      }
      return
    }
    if (!workstationState) {
      if (errorNumRef === 0) {
        errorNumRef = 1
        modalConfirm(
          {
            content: formatMessageNew('languageObj.nsptagLocale.workstationError'),
            cancelText: formatMessageNew('languageObj.nsptagLocale.backText'),
            okText: formatMessageNew('languageObj.nsptagLocale.loginText'),
            onCancel: () => {
              errorNumRef = 0
              history.goBack()
            }
          },
          () => {
            errorNumRef = 0
            clearAuthentication()
            history.push('/login')
          }
        )
      }
      return
    }
    upcNfcInputRef && upcNfcInputRef.current.setTimes()
  }

  const confirmDialog = () => {
    if (errorNumRef === 0) {
      errorNumRef = 1
      modalConfirm(
        {
          content: formatMessageNew('languageObj.nsptagLocale.macError'),
          cancelText: formatMessageNew('languageObj.nsptagLocale.backText'),
          okText: formatMessageNew('languageObj.nsptagLocale.loginText'),
          onCancel: () => {
            errorNumRef = 0
            history.goBack()
          }
        },
        () => {
          errorNumRef = 0
          clearAuthentication()
          history.push('/login')
        }
      )
    }
  }

  return (
    <div
      style={{
        padding: '20px',
        borderRadius: '10px',
        backgroundColor: '#FFF'
      }}
    >
      <Row align={'middle'} style={{ height: 22 }}>
        {isShowUI ? (
          <>
            <Col offset={7} span={8}>
              <span className="ml8">
                &nbsp;
                {formatMessageNew('languageObj.pftag.ao')}
                <span>{orderNumber}</span>
              </span>
            </Col>
          </>
        ) : null}
      </Row>
      <Row className="mt15">
        <Col span={7}>
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <span style={{ textAlign: 'right', marginRight: 5 }}>{formatMessageNew('languageObj.pftag.carton')}</span>
            <Input
              style={{ flex: 1 }}
              value={cartonValue}
              ref={cartonInputRef}
              onChange={e => handleChange(e, { setState: setCartonValue })}
              placeholder={formatMessageNew('languageObj.pftag.pleaseScan')}
              allowClear
              onKeyUp={e => onKeyDown(e)}
              // onBlur={e => onBlurFun(e)}
              // onFocus={e => onFocusFun(e)}
            />
          </div>
        </Col>
        <Col span={16} className="ml8" style={{ display: isShowUI ? 'block' : 'none' }}>
          <TagComp
            ref={upcNfcInputRef}
            tagItem={tagItem}
            confirmDialog={confirmDialog}
            confirmDialogMac={confirmDialogMac}
            // confirmDialog={() => {}}
            // confirmDialogMac={() => {}}
          />
        </Col>
      </Row>
      {isShowUI ? (
        <>
          <div className="content-container">
            <AntdTable dataSource={skuTagList} columns={tableColumns} />
          </div>
          <Row>
            <Col className="mt15" style={{ textAlign: 'center' }} span={24}>
              <Button
                type="primary"
                onClick={() => {
                  resetBtnClick()
                }}
                style={{ width: 100 }}
              >
                {formatMessageNew('languageObj.nsptagLocale.reset')}
              </Button>
              <Button
                type="primary"
                disabled={!(gIsTagAllFlag && !submitFlag)}
                onClick={() => {
                  if (gIsTagAllFlag && !submitFlag) {
                    submitClick()
                  }
                }}
                style={{ width: 100, marginLeft: '20px' }}
              >
                {formatMessageNew('languageObj.pftag.submit')}
              </Button>
            </Col>
          </Row>
        </>
      ) : null}
    </div>
  )
}

export default PFTagPage
